import React,{useState, useEffect} from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Gallery from "./Components/Gallery";
import GalleryEdit2 from "./Components/GalleryEdit2";
import GalleryEdit3 from "./Components/GalleryEdit3";
import GalleryEdit4 from "./Components/GalleryEdit4";
import Loader from "./Components/Loader";
import ImageSlider from "./Components/ImageSlider";

const GalleryPage=()=>{

     useEffect(()=>{
                         document.title="Gallery | Balaji Badminton Academy"
                       },[]);

    return(
        <>
            <Header/>
            <Gallery/>
            <ImageSlider/>
            <Loader/>
            {/* <GalleryEdit3/> */}
            <GalleryEdit2/>
            <GalleryEdit4/>
            <Footer/>   
        </>
    );
}

export default GalleryPage;